import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, List, ListItem, ListItemText, CircularProgress } from '@mui/material';
import api from '../utils/api';

function RecordedTitlesPage() {
  const { station_id } = useParams();
  const [series, setSeries] = useState([]);
  const [stationName, setStationName] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/stations/${station_id}/series`)
      .then(res => {
        const data = res.data || [];
        setSeries(data);
        const name = data[0]?.station_name || station_id;
        setStationName(name);
        document.title = `${name} - 節目列表`;
      })
      .catch(err => {
        console.error('取得節目清單失敗:', err);
      })
      .finally(() => setLoading(false));
  }, [station_id]);

  if (loading) return <CircularProgress />;
  if (series.length === 0) return <Typography>這個電台目前沒有錄製節目</Typography>;

  return (
    <Box>
      <Typography variant="h6" gutterBottom>{stationName}</Typography>
      <List>
        {series.map((item) => (
          <ListItem
            button
            key={item.season_id}
            onClick={() => navigate(`/recorded/seasons/${item.season_id}`)}
          >
            <ListItemText
              primary={item.season_name}
              secondary={item.episode_count != null ? `${item.episode_count} 集` : null}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default RecordedTitlesPage;
